import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import useT from '@/lib/t';

import FullPage from '@/src/components/UI/FullPage';
import TermItem, { rulesType } from '@/src/components/UI/TermItem';

const TermsOfService = () => {
  const t = useT();
  return (
    <FullPage hasHeaderPlaceHolder text={''} title={t('share.header.tos')}>
      <p className='text-2xl leading-loose font-medium text-gray900  mb-7 uppercase'>FUNWOO 服務條款</p>
      {rules.map(({ title, content }, idx) => {
        return <TermItem key={title + idx} title={title} content={content} />;
      })}
    </FullPage>
  );
};

const rules: rulesType = [
  {
    title: '概述',
    content: `歡迎您來到 FUNWOO的公司官網（「本網站」或「本官網」），並使用我們官網所提供、與不動產買賣交易有關的各項法律及稅務…等資訊與服務。本官網是由FUNWOO 公司設置及維護，我們公司的中文名稱為「德載國際不動產股份有限公司」。\n\n如果您繼續造訪和使用本官網及本公司的各項服務，就表示您同意以下所有條款、政策、聲明和相關規定（以下簡稱為「服務條款」或「條款」）的拘束，其中也包括本服務條款所引用的附加條款，或藉由超連結所提供的任何條款和政策。因此，在訪問或使用本官網之前，請您仔細閱讀這些服務條款。如果您不同意本服務條款的一切規定，那麼請您立刻登出，也請您不要繼續使用本官網或使用任何服務。在整個網站中，凡是提到「我們」或「本公司」，都是指「德載國際不動產股份有限公司」。凡是提到「您」，則是指任何造訪本網站或本公司服務的個人、公司行號或團體，而不論您是否加入本官網或公司成為會員。\n\n另外，不論您是供應商、客戶、合作對象、商家或內容提供者，只要您是造訪跟使用本網站的人，這些服務條款都適用於您。我們會不定期地更新或更改我們的網站，或者更新或增刪修改服務條款的任何部分，所以請您隨時查看本官網最新版本的服務條款。\n\n提醒您留意：您有責任定期檢查本官網的服務條款是否有所更改。因為，在本官網發布任何更改的服務條款內容後，如果您繼續使用或訪問本網站，都表示您已接受更改後的條款內容。`,
  },
  {
    title: '第 1 條 原則性條款',
    content: `您必須已經是中華民國法律所定義的成年人，才能造訪本網站跟使用相關服務。如果您並未成年，則請您立即登出本網站。\n\n您不得將我們所提供的任何資訊、內容或服務，用於任何非法或未經授權的目的；您也不得在使用本官網或本公司服務時，違反任何法律的規定。\n\n您不得傳播任何電腦病毒或具有破壞性的軟體。\n\n一旦我們發現您違反任何條款，我們將立即終止相關服務。`,
  },
  {
    title: '第 2 條 得隨時拒絕提供服務；不得擅用官網內容',
    content: `我們隨時可以任何理由、拒絕向您或任何人提供服務。\n\n如果沒有獲得我們事先的書面許可，您不得複製、出售、轉售或以其他方式利用本官網或本公司服務的任何部分。\n\n本服務條款中所使用的各項標題，僅是為了方便您閱讀或參考而設，但這些標題並不是條款的一部份，也不能因此而拘束或限制相關條款的解釋或執行。`,
  },
  {
    title: '第 3 條 資訊的準確性、完整性和及時性',
    content: `除了法律有特別規定，如果本網站提供的資訊存有不準確、不完整或不即時的情形，我們並不承擔任何法律責任。本網站上的所提供的任何資訊，都僅供您參考使用，請您不要拿來作為您決策的唯一依據，而應設法取得更準確、更完整或更及時的資訊，或與其他資訊來源比對確認。\n\n另外，本網站可能包含某些歷史資訊（包括不動產的成交資訊）。這些歷史資訊，必然不是最新的，而只供您參考。我們雖然會不定期修改或更新本網站的內容，但除了法律有特別規定外，我們並無隨時更新網站上任何資訊的義務。`,
  },
  {
    title: '第 4 條 智慧財產權',
    content: `本官網服務的內容，例如：圖片、檔案、資訊、資料、流程架構、介面的安排、介面設計，均由本官網或其他權利人依法擁有其智慧財產權（包含營業秘密），任何人不得擅自使用或侵害。若您欲利用本官網內容或任何智慧財產，必須依法取得本官網或其他權利人的事前書面同意。\n\n尊重智慧財產權是您應盡的義務，如有違反，您應自負一切法律責任，並對本公司負擔損害賠償責任。`,
  },
  {
    title: '第 5 條 對服務和服務費的修改',
    content: `在遵循相關法令的前提下，我們可能會：
    變動提供的服務內容或服務費，而不見得會提前通知您。\n\n我們也可能會隨時修改或停止我們提供的服務或內容，而毋須事前通知您。\n\n如果發生上述的情形，我們毋須對您或任何第三人負責。`,
  },
  {
    title: '第 6 條 專營台灣不動產物件；線上瀏覽物件',
    content: `我們是一家設在台灣的公司，依照台灣法律的規定，在台灣提供台灣的不動產仲介銷售的相關服務。未來我們也計畫與國外的不動產開發商及不動產仲介同業合作，依照相關法令規定，銷售海外不動產。\n\n如果您透過本官網瀏覽我們仲介銷售的不動產物件相關資訊或服務，則請您務必留意：雖然我們已盡一切努力、儘可能準確地展示這些物件的規格、格局和附近環境、室內裝修的圖像，但我們無法保證能準確地在您使用的裝置或設備中顯現出來。在您做出決定前，我們強烈建議您親自或委託他人到物件現場察看物件現況，並詳細閱覽我們提供的不動產說明書跟現況說明書。`,
  },
  {
    title: '第 7 條 第三方所提供的服務或工具',
    content: `我們可能會您提供相關連結或說明，以供您使用第三方工具或服務（例如：內政部或民間業者所建置的實價登錄資訊網站或 APP）。不過，請您留意：我們既無法監督該第三方，對其也沒有任何控制力。\n\n因此，您瞭解並同意，針對這些第三方工具，我們不提供任何擔保。您可以自由選擇是否使用這些第三方工具，但當您決定使用時，需自行承擔風險，也應該熟讀並遵守相關第三方所提供的工具服務條款。\n\n今後，我們也可能透過本網站提供新的服務或功能。當您使用這些新功能或服務時，也同樣受到本服務條款的約束。`,
  },
  {
    title: '第 8 條 與第三方網站的連結',
    content: `我們可能會提供連結，讓您得以造訪其他網站或使用其他網路資源。在您點選這些連結的時候，您會因此連結至其他業者所經營或維護的網站。提醒您：本官網或本公司與這些業者之間，有可能沒有任何合作或從屬關係；此外，這些業者所經營的網站或提供的資源，也均由他們自行負責，而不在本公司或官網所控制或負責範圍內。\n\n本公司對於任何外部連結之網站或資源，並不擔保其一定合用、可依賴、即時、有效、正確或完整。\n\n此外，由於網際網路運作的特性，您也許會檢索或連結到一些令您厭惡的內容，或是不想造訪的網站。在遇到此類情形時，建議您不要繼續瀏覽，而請儘速離開這些網站。\n\n對於前述這些第三方網站提供的商品、服務、資源或內容，我們不承擔任何擔保或損害賠償責任。因此，請您務必仔細查看這些第三方的使用者條款、政策和做法，並在進行任何交易或使用其服務之前，充分瞭解其相關規定、政策和做法。如果您對第三方產品或服務想進行投訴或索賠，請直接與這些第三方業者聯繫。`,
  },
  {
    title: '第 9 條 用戶評論、意見回饋、書信內容往來和其他提交的內容',
    content: `不論您是主動將您的創意、想法、建議、回饋意見或其他資訊傳送給我們，或者您是應我們的要求而發送或發表某些特定評論或意見（例如：消費者建議），不管您是透過線上、電子郵件、郵寄還是其他方式，您都同意：
    我們無償取得這些資訊、創意或內容的一切智慧財產權，並可以不受限制，隨時在任何媒體媒介上，自由利用您發給我們的上述資訊及內容。\n\n我們如果認為您所傳送的或上傳的任何內容或資訊，屬於非法、具有冒犯性，或是屬於威脅、誹謗、色情或其他令人反感的內容，或違反任何人的智慧財產權或本服務條款時，我們都可以直接把它刪除，而不必對您負擔任何法律責任。\n\n您同意您所傳送或提交的前述任何資訊或內容，都不會侵犯任何第三方的任何權利，包括所有權、著作權、商標權、專利權、隱私、或其他個人或專有權利。您並同意：不使用虛假的電子郵件位址，不冒充您以外的人；對於任何資訊或內容的來源，也不誤導我們或其他人。此外，您對您發表的任何資訊的內容及其準確性，應負完全的法律責任。\n\n除了法律有特別規定外，對於您或任何人在本官網或本公司發布的任何訊息或內容，我們不承擔任何法律責任。`,
  },
  {
    title: '第 10 條 個人資訊',
    content: `您通過本官網或本公司所提交的個人資訊，受我們的隱私權政策所拘束。請點選查看我們的隱私權政策。只要本公司或本官網持續運作，在符合法令規定或您授權的前提下，我們都可能會繼續保存或使用您的個人資料。`,
  },
  {
    title: '第 11 條 官網資訊內容發生錯誤、不準確和遺漏之可能',
    content: `有時，在我們的網站上或服務中，對於若干產品的描述、定價、促銷、優惠等相關的資訊，可能因為排版疏失或遺漏，而發生錯誤或遺漏的情形（例如：誤植了某間房屋的售價）。萬一發生這樣的疏失，我們會盡力在合理時間內予以更正；但除了法律有特別規定外，我們無法對這些疏失負擔責任。當然，如果您明知或可得而知上述資訊是因為錯誤或遺漏等疏失所致，也不得要求我們受到這些錯誤疏失的拘束。\n\n除非因為法律的要求，否則，我們不承擔更新、修改或澄清服務或任何相關網站上資訊的義務。`,
  },
  {
    title: '第 12 條 本官網禁止的其他行為',
    content: `除了本服務條款中規定的相關禁止行為外，在使用本網站或其內容時，您也不得從事下列任一項行為；如有發生，我們得隨時禁止您使用本官網或本公司服務：\n\n(1) 除了本服務條款中規定的相關禁止行為外，在使用本網站或其內容時，您也不得從事下列任一項行為；如有發生，我們得隨時禁止您使用本官網或本公司服務：\n\n(2) 引誘他人從事或參與任何非法行為\n\n(3) 違反任何國際條約、公約、協議或、規則、法律或地方法令\n\n(4) 侵害我們或他人的智慧財產權\n\n(5) 騷擾、虐待、侮辱、傷害、誹謗、貶低、恐嚇或基於性別、性取向、宗教、種族、族群、年齡、或身心障礙的歧視\n\n(6) 提交虛假或誤導性資訊\n\n(7) 上傳、傳輸或散佈病毒或任何對電腦軟、硬體產生中斷、破壞或限制功能的其他惡意軟體 \n\n(8) 收集或追蹤他人的個人資訊\n\n(9) 垃圾郵件、網路釣魚或其他類似手法\n\n(10) 違反依法律或契約所應負之保密義務\n\n(11) 從事未經本平台事前授權或同意的商業行為\n\n(12) 出於任何淫穢或不道德的目的\n\n(13) 干擾或規避本官網服務或任何相關網站、網路的安全功能\n\n(14) 其他不符本官網或服務所提供的使用目的之行為，或本公司認為不適當之行為`,
  },
  {
    title: '第 13 條 免責聲明及責任限制',
    content: `我們可能會隨時取消服務，而無需事先通知您。\n\n您使用我們的官網或服務時，我們不保證相關連結或服務一定不會中斷，也不保證我們的內容或服務一定及時、安全或毫無差錯。\n\n本官網服務如果出現中斷或故障等現象，或許將造成您在使用上的不便、資料喪失、錯誤、遭人篡改或其他經濟上損失等情形。因此，在使用本官網或相關服務前，您應該自行採取防護措施。除了法律有規定者外，本公司對於您因使用（或無法使用）本官網或相關服務而造成的損害，不負任何賠償責任。\n\n除了法律有特別規定外，在任何情況下，如果您因為使用本官網或本公司其他服務，遭受任何損失或損害時，不論是直接或間接損害，也不管是否損害範圍有多大，我們公司的任何人員（例如：董事、管理人員、員工、附屬公司、代理人、承包商、實習生、供應商、服務提供者或其他合作廠商），都無須負擔任何賠償責任。\n\n您明確了解並同意：於法律許可之最大範圍內，本公司針對本官網或本服務，不提供任何明示或默示的擔保。此外，本官網及服務乃依「現狀」提供；您使用本服務時，須自行承擔相關風險。`,
  },
  {
    title: '第 14 條 賠償',
    content: `如果在您使用本官網或服務時，任何故意或過失之舉（例如：違反本服務條款），或您違反任何法律或第三人權益，導致該第三人或政府單位出面對本公司任何人員（例如：董事、管理人員、員工、附屬公司、代理人、承包商、實習生、供應商、服務提供者或其他合作廠商）主張權益、請求損害賠償或處罰時，您同意無條件賠償本公司（包含：律師費、和解金）。`,
  },
  {
    title: '第 15 條 使用者條款發生一部無效的情形',
    content: `如果本服務條款的任一部份被法院認定為非法、無效或不可執行時，則在法律允許的範圍內，本服務條款其他部分仍為有效，且應得到充分執行。前述任何不可執行的部分，應被視為與本服務條款分開，而影響任何其他剩餘條款的有效和執行。`,
  },
  {
    title: '第 16 條 服務條款的終止',
    content: `除非您和我們共同同意終止本服務條款，否則本服務條款持續有效。此外，在終止日期前所發生的一切權利和義務，即便在本服務條款終止之後，仍應依法履行。`,
  },
  {
    title: '第 17 條 準據法及管轄權',
    content: `對於本服務條款的解釋與適用，以及與本服務條款有關的爭議，或因本服務條款而產生或與之相關的任何法律程序，您同意以中華民國（台灣）法律為準據法，並由台灣台北地方法院管轄。您並同意：您目前所在地任何「法律衝突適用法」規定，均不拘束本服務條款及本公司。`,
  },
  {
    title: '第 18 條 服務條款變更',
    content: `我們會不定時更新和更改我們的網站內容或服務，也可能會隨時更新、增刪修改本服務條款的任何部分規定。您有責任定期查看我們的網站內容、服務或服務條款是否有更改。在我們發佈這些更改後的服務條款後，如果您繼續使用或訪問我們的網站或服務，就表示您對接受這些更改。`,
  },
  {
    title: '第 19 條 聯繫資訊',
    content: `如果有任何關於本服務條款的問題，歡迎電子郵件聯繫我們 info@funwoo.com.tw。`,
  },
];
export default TermsOfService;

export const getStaticProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};
